var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSigninpage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.99,
    y: 130.01,
    width: 14.17,
    height: 44.11,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.57 174.12 364.55 174.12 357.45 122.49 404.47 122.49 411.57 174.12",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.66 174.12 368.1 174.12 361 122.49 409.56 122.49 416.66 174.12",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.61 170.05 365.63 126.56 406.05 126.56 412.04 170.05 371.61 170.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.6,156.88l-2.25-16.32a3,3,0,0,1,3-3.46h14.69a3,3,0,0,1,3,2.63l2.24,16.33a3,3,0,0,1-3,3.45H382.61A3,3,0,0,1,379.6,156.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.16,
    y: 81.68,
    width: 211.79,
    height: 130.65,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.7,
    y: 81.68,
    width: 214.69,
    height: 130.65,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.16,
    y: 212.34,
    width: 211.79,
    height: 10.11,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.76,
    y: 212.34,
    width: 214.69,
    height: 10.11,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.33,
    y: 47.28,
    width: 115.42,
    height: 199.45,
    transform: "translate(330.05 -36.03) rotate(90)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.96 204.72 142.67 89.3 163.77 89.3 119.06 204.72 97.96 204.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.6 204.72 168.31 89.3 176.53 89.3 131.82 204.72 123.6 204.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.82 204.72 246.53 89.3 254.75 89.3 210.05 204.72 201.82 204.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.57,
    y: 146.53,
    width: 115.42,
    height: 0.97,
    transform: "translate(429.29 -135.27) rotate(90)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.66,
    y: 174.12,
    width: 44.84,
    height: 208.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440.99 382.4 445.5 382.4 445.5 369.57 436.26 369.57 440.99 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.09,
    y: 174.12,
    width: 44.84,
    height: 208.28,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.99,
    y: 174.12,
    width: 82.51,
    height: 200.41,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.5 382.4 362.99 382.4 362.99 369.57 372.23 369.57 367.5 382.4",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 177.79,
    width: 75.51,
    height: 94.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,185.15H396.07a25.87,25.87,0,0,1-18.78-8.08H431.2A25.84,25.84,0,0,1,412.42,185.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.49,
    y: 276.16,
    width: 75.51,
    height: 94.54,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.42,283.52H396.07a25.87,25.87,0,0,1-18.78-8.08H431.2A25.84,25.84,0,0,1,412.42,283.52Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.5 239.89 204.12 239.89 214.94 283.96 140.31 283.96 129.5 239.89",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.31 283.96 140.62 286.39 215.24 286.39 214.94 283.96 140.31 283.96",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.8 239.89 206.42 239.89 217.24 283.96 142.61 283.96 131.8 239.89",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.19 281.94 134.36 241.9 204.84 241.9 214.67 281.94 144.19 281.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.06 283.96 162.36 286.39 244.53 286.39 244.23 283.96 162.06 283.96",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.34,
    y: 286.39,
    width: 8.94,
    height: 96,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.9,
    y: 286.39,
    width: 6.21,
    height: 96,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.82,
    y: 286.39,
    width: 115.21,
    height: 10.99,
    transform: "translate(420.86 583.77) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.88,
    y: 297.38,
    width: 8.94,
    height: 85.01,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.43,
    y: 297.38,
    width: 6.21,
    height: 85.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.29,
    y: 297.38,
    width: 8.94,
    height: 85.01,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.85,
    y: 297.38,
    width: 6.21,
    height: 85.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.76,
    y: 297.38,
    width: 8.94,
    height: 85.01,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.31,
    y: 297.38,
    width: 6.21,
    height: 85.01,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.29,
    y: 286.39,
    width: 69.53,
    height: 10.99,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,382.4h-2.17L284,351.76l-1.09-5.37L276.07,313h-26L236,382.4H233.8l14.36-70.68a1.05,1.05,0,0,1,1-.85H277a1,1,0,0,1,1,.85l6,29.32L285,346.4Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09,382.4h-2.18L317.81,313h-26L285,346.4,284,351.76l-6.23,30.64h-2.17l7.31-36,1.08-5.35,6-29.32a1.06,1.06,0,0,1,1-.85h27.75a1.05,1.05,0,0,1,1,.85Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,311.93h47.78c9.12,0,14.18-6.2,16.76-16.42l1.26-5.84a12,12,0,0,0-11.69-14.81h-30c-6.2,0-7.84,1.48-12.13,10.82S270,311.93,270,311.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.75,302.77h50.92a2.39,2.39,0,0,1,2.39,2.39v.22a6.54,6.54,0,0,1-6.54,6.54H242.75a0,0,0,0,1,0,0v-9.16a0,0,0,0,1,0,0Z",
    transform: "translate(538.8 614.7) rotate(-180)",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-3",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-female--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "203.03 384.25 196.63 388.37 185.03 374.88 191.43 370.76 203.03 384.25",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.44 370.76 185.03 374.88 191.02 381.84 197.42 377.71 191.44 370.76",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.12 406.25 146.76 406.97 139.11 389.47 146.47 388.75 154.12 406.25",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.12 389.48 143.06 398.5 150.73 398.5 146.47 388.76 139.12 389.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.23,170c-3.7.33-3.8-5.95-10.3-3-8.26,3.76-5.47,9.59-11.92,9.35s-10.77,4.79-9.33,8.54,3.67,7.3-.89,8.81-7.66,2.84-7,6.62,3.89,5.3-1.55,7.71-4.89,12.83.44,12.84.22,5.2,5,10.48,12.05,6,15.08,3.4S84.17,230,89.87,234s15.35,5,14.91-1.34-6-10.5-.76-13.8,12-4.93,9.88-11.35c-1.35-4-5.43-7.48-2.14-10.47,5.35-4.86,5.38-15.86-1.18-18.65C106.77,176.78,110.44,168.9,98.23,170Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.11,219.42c-.18,3-.56,5.67-1,8.48s-1.08,5.55-1.81,8.3a61.42,61.42,0,0,1-2.71,8.16c-.54,1.34-1.16,2.67-1.82,4-.33.66-.69,1.31-1.06,1.95-.17.33-.38.65-.57,1l-.29.47a7.23,7.23,0,0,1-.66.89,5.89,5.89,0,0,1-2,1.47,6.37,6.37,0,0,1-2.16.55,8.55,8.55,0,0,1-3.24-.44,19.61,19.61,0,0,1-4.4-2.16,54.25,54.25,0,0,1-6.83-5.29,114.53,114.53,0,0,1-11.47-12.07L53.93,232c2,1.76,4,3.55,6.09,5.25s4.13,3.41,6.26,5a52.62,52.62,0,0,0,6.4,4.22,12.86,12.86,0,0,0,3,1.23,1.87,1.87,0,0,0,.78.07l-.2,0a1.43,1.43,0,0,0-.36.25l-.05.05s0,.07,0,0l.22-.41c.14-.27.3-.53.43-.81q.42-.83.81-1.68c.5-1.14,1-2.3,1.4-3.51.84-2.4,1.54-4.88,2.16-7.4s1.09-5.09,1.51-7.68.74-5.24,1-7.7Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,220.36c-.4,2.42-2.41,7-4,10.4-1.18,2.46-2.14,4.31-2.14,4.31l-1.4-.62-11.59-5.16c.88-6.25,2.31-13,9.2-16.07C91.29,211.32,97.63,216,96.92,220.36Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.92,220.36c-.4,2.42-2.41,7-4,10.4-1.18,2.46-2.14,4.31-2.14,4.31l-1.4-.62-11.59-5.16c.88-6.25,2.31-13,9.2-16.07C91.29,211.32,97.63,216,96.92,220.36Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.89,230.76c-1.18,2.46-2.14,4.31-2.14,4.31l-1.4-.62c.19-2.47.68-6.36,2-8.11A11,11,0,0,1,92.89,230.76Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,234.29l.92-6.73L47.74,230s1.2,4.07,3.89,5.74Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.87 221.81 46.6 224.7 47.74 230.04 55.29 227.56 51.87 221.81",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.27,386.35l6.95-5a.61.61,0,0,1,.8.07l4.73,4.93a1.22,1.22,0,0,1-.2,1.81c-2.45,1.7-3.72,2.39-6.78,4.58-1.88,1.35-5.84,4.61-8.44,6.47s-4.57-.6-3.66-1.61c4.1-4.52,5.19-7.6,5.84-10.14A2,2,0,0,1,194.27,386.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,404.7h9a.75.75,0,0,1,.71.55l2,7.14a1.12,1.12,0,0,1-1.1,1.43c-3.18,0-4.69,0-8.66,0H135.6c-3.3,0-4-3.34-2.63-3.64,6.12-1.35,9.65-3.22,11.54-5A1.86,1.86,0,0,1,145.79,404.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,247.46l-29.47,9.32c-20.4-40.38-17.49-42.52-17.49-42.52s4.71-2.69,9.61-4.93c.74-.34,1.49-.67,2.23-1a98.38,98.38,0,0,1,13.38-4.24c.67-.18,1.34-.34,2-.5a94,94,0,0,1,11-1.81c.44,5.59.88,10.32,1.36,14.43.62,5.36,1.29,9.65,2,13.36A116.7,116.7,0,0,0,132.05,247.46Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.05,247.46l-29.47,9.32c-20.4-40.38-17.49-42.52-17.49-42.52s4.71-2.69,9.61-4.93c.74-.34,1.49-.67,2.23-1a98.38,98.38,0,0,1,13.38-4.24c.67-.18,1.34-.34,2-.5a94,94,0,0,1,11-1.81c.44,5.59.88,10.32,1.36,14.43.62,5.36,1.29,9.65,2,13.36A116.7,116.7,0,0,0,132.05,247.46Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.75,229.59c-2.83-4-5.54-13.31-4.84-16.8l2.8,3.44C125.33,221.59,126,225.88,126.75,229.59Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.63,221.8s7.43-1.61,9.82,1.62c3.28-3.23,2.12-15.85.54-20.35a19.48,19.48,0,0,0-3.67,1l-5.25,8.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.63,221.8s-5,1.12-5.53,5.21c-7-5.21-6.51-12.84-4.93-17.34a17.64,17.64,0,0,1,3.76-1.32l5.25,5.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,195.59c1,3.68,2.52,7.32,5,8.52,0,0,2.31,6.62-6.69,17.69-9.42-6.71-6.7-13.45-6.7-13.45,4.44-2.67,3.19-6.19,1.3-9.27l2.61-4.19A2.48,2.48,0,0,1,105.34,195.59Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.34,195.59a2.48,2.48,0,0,0-4.51-.7l-.84,1.34h0c.07.89.11,1.62.1,2-.08,2.6,3.57,2.48,6.54,1.23A26.34,26.34,0,0,1,105.34,195.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.25,185.54c2.6,7.09,3.54,10.15,8.3,12.77,7.15,3.95,15.29-.79,14.87-8.52-.38-6.95-4.56-17.39-12.49-18.16A10.31,10.31,0,0,0,87.25,185.54Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.64,174.88c-2.44-2.35-5-5.08-9.9-4.55-5.42.59-7.56,3.87-7.56,3.87l-4.66,10.19s2.89,13.12,7.66,7C93.93,187.85,94,182.5,93,178.5a32.32,32.32,0,0,0,5.52-1.28c2.2.82,4.67.82,6.5-.86.4-.37.69-.66.9-.89l.17-.19C106.63,174.59,106.18,174.66,105.64,174.88ZM99.34,177a52.16,52.16,0,0,1,5.2-1.39A5.13,5.13,0,0,1,99.34,177Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,192.75A5.54,5.54,0,0,0,91,195.28c1.88.47,2.77-1.22,2.2-3-.51-1.57-2.1-3.71-4-3.41A2.49,2.49,0,0,0,87.61,192.75Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.58,256.79s-1,60.39,6.89,82.21c7.6,20.92,30.27,56.88,30.27,56.88l13.14-.33S132,350,128.59,332c-5.68-29.87-4.43-82-4.43-82Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.38,262l3.53-10,6.25-2s-.57,23.73.8,48.34C119.29,287.42,114.38,267.42,114.38,262Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.89 396.56 154.12 396.15 153.18 391.16 135.46 392 137.89 396.56",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,254.84s20.5,46.89,33.75,73.58c10.7,21.56,44,50.48,44,50.48l9.13-6.33s-25.06-34.26-32.45-48.88c-23.65-46.78-17.82-66.06-31.42-76.23Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.29 381.92 198.01 374.29 195.58 369.61 183.8 378.52 187.29 381.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,245.59l2.16,2.22c.17.17,0,.46-.35.57l-30.91,9.77c-.26.09-.52,0-.59-.13l-1.1-2.56c-.08-.17.1-.4.39-.49l29.85-9.45A.56.56,0,0,1,132,245.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,250.2l.8-.25c.16,0,.26-.18.21-.27l-1.45-3.31a.31.31,0,0,0-.37-.09l-.8.26c-.16.05-.26.17-.21.27l1.46,3.3C128.67,250.21,128.83,250.25,129,250.2Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.19,257.73l.8-.25c.16-.05.25-.17.21-.27l-1.46-3.31c0-.1-.21-.13-.37-.08l-.8.25c-.15.05-.25.17-.21.27l1.46,3.31A.32.32,0,0,0,105.19,257.73Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.09,254l.8-.25c.16-.05.26-.17.21-.27l-1.46-3.31c0-.09-.2-.13-.36-.08l-.8.25c-.16,0-.26.17-.21.27l1.45,3.31C116.77,254,116.93,254,117.09,254Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.69,184c.18.59.63,1,1,.86s.55-.69.37-1.27-.62-1-1-.86S99.52,183.39,99.69,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.34,182c.18.59.63,1,1,.86s.55-.68.38-1.27-.63-1-1-.86S106.17,181.41,106.34,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.56,180.81l1.29-.83S107.46,181.3,106.56,180.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.68,183.53a16.73,16.73,0,0,0,3.22,3.13,2.67,2.67,0,0,1-2,1Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,190.9a.18.18,0,0,0,.06-.19.19.19,0,0,0-.22-.13,4.82,4.82,0,0,1-4.34-.69.18.18,0,1,0-.24.28,5.18,5.18,0,0,0,4.68.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.18,182.37a.37.37,0,0,0,.1-.16,2.89,2.89,0,0,1,1.87-1.81.36.36,0,1,0-.15-.7A3.54,3.54,0,0,0,96.61,182a.36.36,0,0,0,.21.47A.41.41,0,0,0,97.18,182.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37,178.23a.25.25,0,0,1,0-.07.38.38,0,0,0-.29-.42,3.61,3.61,0,0,0-3.18.86.36.36,0,1,0,.52.5,2.86,2.86,0,0,1,2.52-.65A.37.37,0,0,0,108.37,178.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.83,208.86c1.19.89,2.19,1.72,3.23,2.62s2,1.8,3,2.74c1.95,1.88,3.83,3.84,5.61,5.9a66.52,66.52,0,0,1,5,6.53c.4.56.75,1.17,1.12,1.75s.74,1.17,1.07,1.79.68,1.17,1,1.86l.53,1.11.43,1.12a26.37,26.37,0,0,1,1.28,8.8,48.68,48.68,0,0,1-.89,8.26c-.52,2.67-1.2,5.28-2,7.84a76.48,76.48,0,0,1-2.82,7.55l-3.62-1.34c.62-2.4,1.21-4.92,1.65-7.41a70.89,70.89,0,0,0,1.07-7.46,48.42,48.42,0,0,0,.17-7.3,29.13,29.13,0,0,0-.42-3.44,19.79,19.79,0,0,0-.91-3.08l-.31-.69-.34-.63c-.27-.46-.64-1-1-1.51s-.66-1-1-1.51-.69-1-1.07-1.48c-1.46-2-3.11-3.82-4.75-5.67s-3.44-3.59-5.27-5.29c-.9-.86-1.83-1.7-2.76-2.52s-1.93-1.64-2.79-2.34Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.92,263l-5.48,4,7,3.7s2.09-3.7,1.42-6.79Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.71 273.49 140.44 275.26 143.49 270.72 136.44 267.02 134.71 273.49",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,201.8c3.83-.17,11.36,9.24,11.36,9.24l-7.82,11.06s-8.78-7-9.46-11.87C116.86,206.08,118.47,202,123.35,201.8Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,201.8c3.83-.17,11.36,9.24,11.36,9.24l-7.82,11.06s-8.78-7-9.46-11.87C116.86,206.08,118.47,202,123.35,201.8Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.64,389.48h-.12a1,1,0,0,1-.8-.61.64.64,0,0,1,0-.62c.49-.84,3.24-1,3.55-1a.19.19,0,0,1,.17.1.18.18,0,0,1,0,.2C193.77,388.29,192.58,389.48,191.64,389.48Zm2.2-1.83c-1.1.08-2.56.34-2.81.78a.24.24,0,0,0,0,.27.67.67,0,0,0,.52.42C192.08,389.18,192.92,388.63,193.84,387.65Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,387.63c-.92,0-2.73-.51-3.07-1.25a.65.65,0,0,1,.2-.76,1,1,0,0,1,.77-.25c1.09.12,2.38,1.89,2.43,2a.17.17,0,0,1,0,.18.19.19,0,0,1-.14.1Zm-2.22-1.9a.57.57,0,0,0-.4.16c-.17.15-.15.27-.12.35.22.48,1.64,1,2.57,1-.46-.57-1.32-1.47-2-1.54Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,406.19a3,3,0,0,1-1.76-.42,1.13,1.13,0,0,1-.46-.87.54.54,0,0,1,.23-.49c.82-.55,3.89.84,4.5,1.13a.17.17,0,0,1,.1.18.18.18,0,0,1-.14.16A12.41,12.41,0,0,1,141.78,406.19Zm-1.43-1.56a.69.69,0,0,0-.36.08.18.18,0,0,0-.07.17.77.77,0,0,0,.32.6c.53.4,1.78.46,3.39.16A11,11,0,0,0,140.35,404.63Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.21,405.88h-.06c-1-.42-3.08-2.07-3-2.92,0-.18.15-.42.61-.47,1.8-.22,2.56,3,2.59,3.18a.19.19,0,0,1-.06.18A.16.16,0,0,1,144.21,405.88ZM142,402.83h-.12c-.19,0-.29.08-.31.17-.06.49,1.36,1.8,2.4,2.37C143.7,404.58,143.05,402.83,142,402.83Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.91,182.79l1.29-.83S100.81,183.28,99.91,182.79Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Account--inject-3"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M288.63,109.67H143.3a11.37,11.37,0,0,0-11.43,12L145.5,404.24a12.77,12.77,0,0,0,12.58,12H303.41a11.36,11.36,0,0,0,11.42-12L301.21,121.67A12.77,12.77,0,0,0,288.63,109.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294,109.67H148.63a11.36,11.36,0,0,0-11.42,12l13.62,282.57a12.77,12.77,0,0,0,12.58,12H308.74a11.36,11.36,0,0,0,11.42-12L306.54,121.67A12.77,12.77,0,0,0,294,109.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,408.24a4.31,4.31,0,0,1-4.19-4L145.21,121.67a3.82,3.82,0,0,1,3.81-4H294.35a4.29,4.29,0,0,1,4.19,4l13.62,282.57a3.82,3.82,0,0,1-3.8,4Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.93,406.24a2.18,2.18,0,0,1-2.1-2L147.21,121.67a1.93,1.93,0,0,1,1.9-2H294.44a2.17,2.17,0,0,1,2.1,2l13.62,282.57a1.93,1.93,0,0,1-1.9,2Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.79,390H178a3.12,3.12,0,0,1-3.08-2.94l-2.1-43.71a2.81,2.81,0,0,1,2.83-3h28.84a3.1,3.1,0,0,1,3.07,2.93L209.63,387a2.82,2.82,0,0,1-2.84,3Zm-31.18-48.63a1.86,1.86,0,0,0-1.34.56,1.89,1.89,0,0,0-.5,1.37L175.88,387a2.11,2.11,0,0,0,2.08,2h28.83a1.83,1.83,0,0,0,1.84-1.94l-2.11-43.71a2.1,2.1,0,0,0-2.07-2Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.07,351.52H177a.5.5,0,0,1,0-1h27.1a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.35,357.17H177.24a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h27.11a.5.5,0,0,1,.5.5A.51.51,0,0,1,204.35,357.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.62,362.82H177.51a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h27.11a.5.5,0,0,1,.5.5A.5.5,0,0,1,204.62,362.82Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,368.47h-27.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h27.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,204.89,368.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.16,374.12h-27.1a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h27.1a.5.5,0,0,1,.5.5A.5.5,0,0,1,205.16,374.12Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.88,379.77H178.33a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h21.55a.5.5,0,0,1,.5.5A.51.51,0,0,1,199.88,379.77Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.94,229.63l-19.77,3.16a23,23,0,0,0-3-5.27,14.15,14.15,0,0,0-4.13-3l.74,15.5q16.49,4.34,22.19,9.16a22.26,22.26,0,0,1,8,16.45A21.81,21.81,0,0,1,227,276.37a24.37,24.37,0,0,1-6.25,8.15,25.07,25.07,0,0,1-8.37,4.74A41.27,41.27,0,0,1,201.28,291l.13,2.73a3.69,3.69,0,0,1-3.72,3.91h0a4.15,4.15,0,0,1-4.1-3.91l-.13-2.73a50.51,50.51,0,0,1-12.89-2.54,27.62,27.62,0,0,1-8.71-5.11A27,27,0,0,1,166,276.3a34,34,0,0,1-3.33-9.13l21.51-2.51q1.22,5.29,3,7.65a14.45,14.45,0,0,0,5.58,4.18l-.91-18.92a105.82,105.82,0,0,1-15.6-5.2,21.93,21.93,0,0,1-8.18-7.05,21.19,21.19,0,0,1-3.89-11.82,20.22,20.22,0,0,1,5.9-15.94q6.36-6.41,19.5-7.1l-.07-1.39a3.69,3.69,0,0,1,3.72-3.91h0a4.15,4.15,0,0,1,4.1,3.91l.07,1.39q12,.75,18.61,5.68A24.26,24.26,0,0,1,224.94,229.63Zm-34.7-5.35a9.41,9.41,0,0,0-4.63,2.79,5.88,5.88,0,0,0-1.15,3.93,6.86,6.86,0,0,0,1.56,4.12,10.7,10.7,0,0,0,4.89,2.93ZM200.61,277q4.5-1,6.5-3.36a7.24,7.24,0,0,0,1.86-5.24,7.43,7.43,0,0,0-2-4.65c-1.26-1.41-3.66-2.73-7.18-3.94Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.2,146.56h-99l9.65,200.11a32.4,32.4,0,0,0,32,30.54h99L309.21,177.1A32.38,32.38,0,0,0,277.2,146.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.45,146.56H178.23a32.39,32.39,0,0,1,32,30.54L218.1,340a32.4,32.4,0,0,0,32,30.54h62.13A28.84,28.84,0,0,0,341.32,340L333.46,177.1A32.38,32.38,0,0,0,301.45,146.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,340a28.83,28.83,0,0,1-29.06,30.54H373.33A28.84,28.84,0,0,0,402.4,340Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,247.67H231.72a2.41,2.41,0,0,1-2.38-2.27h0a2.15,2.15,0,0,1,2.16-2.27h87.08A2.41,2.41,0,0,1,321,245.4h0A2.15,2.15,0,0,1,318.8,247.67Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.48,261.84H232.4a2.41,2.41,0,0,1-2.38-2.27h0a2.15,2.15,0,0,1,2.16-2.27h87.09a2.41,2.41,0,0,1,2.37,2.27h0A2.15,2.15,0,0,1,319.48,261.84Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.17,276H233.08a2.41,2.41,0,0,1-2.38-2.27h0a2.15,2.15,0,0,1,2.16-2.27H320a2.41,2.41,0,0,1,2.38,2.27h0A2.15,2.15,0,0,1,320.17,276Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.85,290.19H233.77a2.42,2.42,0,0,1-2.38-2.27h0a2.15,2.15,0,0,1,2.16-2.27h87.08a2.41,2.41,0,0,1,2.38,2.27h0A2.15,2.15,0,0,1,320.85,290.19Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.91,304.36H234.45a2.41,2.41,0,0,1-2.38-2.27h0a2.15,2.15,0,0,1,2.16-2.27h52.46a2.41,2.41,0,0,1,2.38,2.27h0A2.15,2.15,0,0,1,286.91,304.36Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.9,
    cy: 198.71,
    rx: 26.71,
    ry: 28.03,
    transform: "translate(-59.92 255.19) rotate(-45.69)",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.48,198.7a21.91,21.91,0,0,1-2.21,10.76A21.27,21.27,0,0,1,274,221.28a23.86,23.86,0,0,1-20.42-11.82,23.24,23.24,0,0,1-3.25-10.76,21.32,21.32,0,0,1,21.49-22.58A24,24,0,0,1,295.48,198.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.27,209.46A21.27,21.27,0,0,1,274,221.28a23.86,23.86,0,0,1-20.42-11.82,34.2,34.2,0,0,1,19.56-6A37,37,0,0,1,293.27,209.46Z",
    style: {
      fill: "#5A887A",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 272.53,
    cy: 190.98,
    rx: 9.82,
    ry: 10.3,
    transform: "translate(-54.51 252.57) rotate(-45.69)",
    style: {
      fill: "#5A887A",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-male--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "356.76 408.74 349.42 408.74 348.68 391.72 356.03 391.72 356.76 408.74",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.69 391.73 349.06 400.5 356.41 400.5 356.03 391.73 348.69 391.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.29 388.8 412.31 391.08 403.52 376.05 410.51 373.77 419.29 388.8",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.51 373.77 403.52 376.05 408.06 383.8 415.04 381.52 410.51 373.77",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.6,162.92c.91,1.11,1.68,2.1,2.47,3.19s1.54,2.13,2.29,3.21c1.48,2.17,2.9,4.39,4.23,6.68a74.91,74.91,0,0,1,6.73,14.71l.17.5.08.26.11.41.2.82.11.75a15,15,0,0,1,.11,2.71,27.38,27.38,0,0,1-.66,4.53,53,53,0,0,1-2.51,7.82,90.83,90.83,0,0,1-7.16,14l-5-2.39c1.5-4.69,3-9.49,4.1-14.16a56.82,56.82,0,0,0,1.3-6.84,17.35,17.35,0,0,0,.11-3,6,6,0,0,0-.14-1.06l-.05-.18a.93.93,0,0,1-.05-.1l0,0-.08-.19-.16-.39-.67-1.57-.75-1.56c-.5-1-1.05-2.08-1.6-3.12-1.14-2.06-2.37-4.11-3.65-6.15s-2.64-4-4-6-2.85-4-4.2-5.81Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.23,218.88l-2.87,6.35h8.21s1.31-4.82-1.67-6.77Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.32 232.37 388.94 230.9 388.57 225.23 380.36 225.23 381.32 232.37",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.22,130.69c0,.6-.31,1.08-.7,1.08s-.7-.48-.7-1.08.32-1.07.7-1.07S345.22,130.1,345.22,130.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,131.77a21,21,0,0,1-2.83,5.06,3.43,3.43,0,0,0,2.83.54Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.32,127.41a.31.31,0,0,1-.2-.07,2.8,2.8,0,0,0-2.47-.45.35.35,0,0,1-.25-.65,3.45,3.45,0,0,1,3.13.54.36.36,0,0,1,.08.49A.37.37,0,0,1,347.32,127.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.35,137.52c-1.06,5.38-2.11,15.23,1.65,18.81,0,0-1.47,5.45-11.45,5.45-11,0-5.25-5.45-5.25-5.45,6-1.43,5.84-5.87,4.79-10.05Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.44,158.2c.79-1.72,1.66-3.7-.14-4.32-2-.68-12.76-1.37-16.49-.09a3.84,3.84,0,0,0-2.66,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.8,392.83c-.54.52-1.15.94-1.61.87a.72.72,0,0,1-.57-.6.8.8,0,0,1,.12-.67c.6-.93,3-1.33,3.13-1.34a.18.18,0,0,1,.17.07.17.17,0,0,1,0,.19A9.23,9.23,0,0,1,410.8,392.83Zm-1.63-.38a1,1,0,0,0-.14.16.48.48,0,0,0-.07.4c.08.31.23.34.28.34.51.08,1.6-1,2.27-1.84A5.77,5.77,0,0,0,409.17,392.45Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,391.38l-.08.05c-.83.22-3,.08-3.46-.62a.59.59,0,0,1,.08-.72,1,1,0,0,1,.69-.35c1.1-.08,2.69,1.33,2.76,1.39a.16.16,0,0,1,.05.17A.12.12,0,0,1,412,391.38Zm-3.13-1.12-.06.06c-.14.17-.08.26-.06.3.27.41,1.79.64,2.73.53a4.31,4.31,0,0,0-2.22-1.06A.59.59,0,0,0,408.89,390.26Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,409.11c-.94,0-1.85-.13-2.15-.55a.64.64,0,0,1,0-.76.87.87,0,0,1,.55-.41c1.22-.33,3.79,1.13,3.9,1.2a.16.16,0,0,1,.08.18.17.17,0,0,1-.13.14A13.43,13.43,0,0,1,346.46,409.11Zm-1.16-1.42a1.22,1.22,0,0,0-.34,0,.51.51,0,0,0-.34.24c-.12.22-.08.33,0,.39.34.47,2.2.48,3.56.29A7.82,7.82,0,0,0,345.3,407.69Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.68,408.91h-.07c-.88-.4-2.64-2-2.51-2.82,0-.2.17-.44.65-.49a1.33,1.33,0,0,1,1,.3c.93.77,1.13,2.75,1.14,2.83a.21.21,0,0,1-.08.16A.17.17,0,0,1,348.68,408.91Zm-1.79-3h-.1c-.32,0-.34.15-.34.19-.08.5,1.11,1.75,2,2.29a4,4,0,0,0-1-2.26A.92.92,0,0,0,346.89,405.93Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.7,390.27l6-5.71a.63.63,0,0,1,.8-.07l5.56,3.72a1.07,1.07,0,0,1,.12,1.68c-2.11,2-3.24,2.81-5.86,5.31-1.62,1.55-6.44,6.8-8.67,8.94s-4.63.2-3.91-.87c3.24-4.81,5.26-9.42,5.44-11.85A1.84,1.84,0,0,1,411.7,390.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.46,407.89h8a.63.63,0,0,1,.62.5l1.45,6.53a1.06,1.06,0,0,1-1.05,1.3c-2.9,0-7.08-.21-10.72-.21-4.25,0-7.92.23-12.91.23-3,0-3.85-3.05-2.59-3.33,5.74-1.25,10.44-1.39,15.4-4.45A3.44,3.44,0,0,1,349.46,407.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,173c-2.92,4.3-5.93,8.32-9.17,12.29a138.12,138.12,0,0,1-10.41,11.48L318,198.15l-.36.34-.26.24L317,199a9.7,9.7,0,0,1-1.51,1,13.46,13.46,0,0,1-5.45,1.53,30.69,30.69,0,0,1-8.66-.72,65.23,65.23,0,0,1-14.85-5.22l1.84-5.2a116.73,116.73,0,0,0,14.18,1.94,26.15,26.15,0,0,0,6.27-.26,4,4,0,0,0,1.66-.65c.05,0,0-.06,0-.06h0s0,0,0,0l.08-.08.29-.33,1.19-1.3c3.12-3.56,6.15-7.36,9.09-11.24s5.89-7.86,8.7-11.74Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.16,158c6.88,1.58,14.78,20.35,14.78,20.35l-13.83,9.48A115.93,115.93,0,0,1,371,172.29C366.9,163.7,372.12,156.38,379.16,158Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.22,170l6.54,17.41-.65.45s-2.83-4-5.89-9.33Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338,158.37s-7.82,8.83-.43,63.5h39.29c.27-6-3.52-35.46,2.3-63.88A102.86,102.86,0,0,0,366,156.33a145.27,145.27,0,0,0-16.7,0A73.5,73.5,0,0,0,338,158.37Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.36,174.18A34.86,34.86,0,0,1,334.6,191c-.16-3.52-.22-6.68-.21-9.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.75,164.33c1,6.95-12.74,24.72-12.74,24.72l-13.77-9.48s3.82-9.79,10.25-16.21C336.84,156,344.7,156.76,345.75,164.33Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.32,191l-5.39-5.57-5.75,7.41s4.38,4.23,9.59,3Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.53 182.33 274.06 190.11 278.18 192.81 283.93 185.4 276.53 182.33",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,129.44c-.45,7.27-.34,11.56-4,15.29-5.53,5.62-14.51,2.29-16.24-5-1.57-6.54-.57-17.34,6.55-20.23A9.94,9.94,0,0,1,365,129.44Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.33,114.25c2.24,2.06,1.29,4.36.12,4.79,3.63.75,4.16,3.64,2.25,9.74-1.82,5.84-6.23,13.67-11.74,14.15-8.28.72-10.7-7.91-10.76-16.47-4.68.29-2.66-3.86-8.41-2.9-5,.83-3.12-3.07-7.37-4.77-4.93-2-3.94-9.55.66-7.38,0,0-2.13,1.4.35,2.72s2.24-1.73,7.15-2.1,5.48,3.83,11.22,1.3C362,110.15,366.73,110,371.33,114.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.57,119a2.87,2.87,0,0,1,3.19-1.25c2.25.48,2.43,1.47,3.84,1.34s.9,1.37.9,1.37-.38-1.13-2.08-.5-2.81-.91-3.54-.22S368.57,119,368.57,119Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.12,131.42a8.15,8.15,0,0,1-2.57,4.62c-1.78,1.58-3.32.31-3.38-1.85,0-1.95.83-5.13,2.88-5.89S355.49,129.26,355.12,131.42Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.5,221.87S359.84,278,364.42,299c5,23,39.85,84.2,39.85,84.2l12.8-4.16s-27.75-55.14-30.61-77.95c-3.11-24.75-9.6-79.26-9.6-79.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.69,379.2c-.05,0,2.93,4.48,2.93,4.48L418,379l-1.69-4.3Z",
    style: {
      fill: "#5A887A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,241.87c9.64,1.89,8.62,37.84,7.46,56.33-2.78-13.07-6.85-38.22-9.63-56.07A3.29,3.29,0,0,1,356.77,241.87Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.57,221.87s-1,54.93-.22,77.33c.83,23.3,9,99.6,9,99.6h12.45s.45-74.94,1-97.82c.6-25,3.61-79.11,3.61-79.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.93,393.84c-.06,0,.7,5.17.7,5.17h15.14l.41-4.61Z",
    style: {
      fill: "#5A887A"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigninpage);
export default __webpack_public_path__ + "static/media/signinpage.beda8c2075323a82d392ec41292a85cc.svg";
export { ForwardRef as ReactComponent };